import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LorenAssetRefresherService {
  private assetSubject = new BehaviorSubject(false);
  refresh$ = this.assetSubject.asObservable();

  private assetSelectionSubject: BehaviorSubject<number> =
    new BehaviorSubject<number>(null);
  selectAsset$ = this.assetSelectionSubject.asObservable();

  refreshAssetData(shouldRefresh?: boolean) {
    this.assetSubject.next(shouldRefresh);
  }

  selectAsset(assetId?: number) {
    this.assetSelectionSubject.next(assetId);
  }
}
